// Create common types for a specific resource
const addCommonActionTypes = (resource) => {
  return {
    GET_ONE: `GET_${resource}`,
    GET_ALL: `GET_${resource}S`,
    EDIT_ONE: `EDIT_${resource}`,
    CREATE_ONE: `CREATE_${resource}`,
    UPDATE_ONE: `UPDATE_${resource}`,
    DELETE_ONE: `DELETE_${resource}`,
  };
}

// Auth
export const authTypes = {
  LOG_IN: 'LOG_IN',
  LOG_OUT: 'LOG_OUT',
  SIGN_UP: 'SIGN_UP',
  REGISTER: 'REGISTER_EMAIL',
  REFRESH_TOKEN_SUCCESS: 'REFRESH_TOKEN_SUCCESS',
  REFRESH_TOKEN_FAILURE: 'REFRESH_TOKEN_FAILURE',
}

// Users
export const userTypes = {
  ...addCommonActionTypes('USER'),
  SET_USER: 'SET_USER',
}
